import { auth, User } from 'firebase/app';
import { useEffect, useState } from 'react';

export const useAuth = () => {
  const [state, setState] = useState(() => {
    const user = auth().currentUser;
    return { initializing: !user, user, };
  });

  function onChange(user: User | null) {
    setState({initializing: false, user});
  }

  function signOut() {
    auth().signOut();
  }

  useEffect(() => {
    const unsubscribe = auth().onAuthStateChanged(onChange);
    return () => unsubscribe();
  }, []);

  return {...state, signOut};
}